module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-lokale-energie-circle-e8dc917d55da447f55b00676e8957ec7.svg";